import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirects old /hiring/* and /people/* URLs to /talentx/* and /peoplex/*
 * preserving the sub-path.
 */
const LegacyRedirect = function (): JSX.Element | null {
  const { pathname, search, hash } = useLocation();

  let newPath: string | null = null;

  if (pathname.startsWith('/hiring/') || pathname === '/hiring') {
    newPath = pathname.replace(/^\/hiring/, '/talentx');
  } else if (pathname.startsWith('/people/') || pathname === '/people') {
    newPath = pathname.replace(/^\/people/, '/peoplex');
  }

  if (newPath) {
    return <Navigate to={`${newPath}${search}${hash}`} replace />;
  }

  return null;
};

export default LegacyRedirect;
